export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Käsittelymaksut',
  description:
    'Maksat Stripen maksut jokaisesta verkkomaksusta. Täällä asetettu käsittelymaksu veloitetaan ravintoloiltasi niiden kattamiseksi, ellei ravintolalla ole omaa hintaa.',
  card_title: 'Oletuskäsittelymaksu',
  hint: 'Prosentti %-muodossa sekä valinnainen kiinteä ja vähimmäismäärä maksua kohden. ”Mikä tahansa maksutapa” on voimassa, kun maksutapakohtaista hintaa ei ole. Muutos koskee tallennuksen jälkeen tehtyjä maksuja.',
  hint_single:
    'Palkkio koskee jokaista verkkomaksutapaa, jolla ei ole omaa hintaa. Muutos koskee muutoksen tallentamisen jälkeen tehtyjä maksuja.',
  hidden_rates:
    'Joillakin maksutavoilla on myös oma hintansa, jonka alustan tuki on määrittänyt. Ne korvaavat tämän hinnan.',
  empty: {
    title: 'Oletuskäsittelymaksua ei ole asetettu',
    description:
      'Siihen asti, kun asetat hinnan tai vahvistat, ettet veloita ravintoloiltasi käsittelymaksua, Stripeä käyttävät ravintolasi eivät voi aloittaa toimintaansa ja toiminnassa olevat eivät ota vastaan verkkomaksuja (käteinen toimii edelleen).',
  },
  consent: {
    give: 'Maksamme Stripen maksut itse (vahvista 0 %:n marginaali)',
    given_title: '0 %:n marginaali vahvistettu',
    given:
      'Vahvistanut {{name}} {{date}}: ravintoloilta, joilla ei ole omaa hintaa, ei veloiteta käsittelymaksua, ja sinä maksat Stripen maksut niiden maksuista.',
    unknown_manager: 'entinen esihenkilö',
    withdraw: 'Peruuta vahvistus',
    withdraw_confirm: {
      title: 'Perutaanko 0 %:n marginaalivahvistus?',
      description:
        'Ravintolat, joilla ei ole omaa hintaa, eivät silloin voi aloittaa toimintaa, ja jo toiminnassa olevat lopettavat verkkomaksujen vastaanoton, kunnes asetat hinnan tai vahvistat uudelleen.',
    },
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  toasts: {
    load_error: 'Käsittelymaksujasi ei voitu ladata.',
    failed_to_save_changes: 'Käsittelymaksujasi ei voitu tallentaa.',
    changes_got_saved: 'Käsittelymaksut tallennettu',
    consent_given: '0 %:n marginaali vahvistettu',
    consent_withdrawn: 'Vahvistus peruttu',
  },
};
